import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  SvgAutotrasporto,
  SvgConducenti,
  SvgNautica,
  SvgVeicoli,
} from "../../components/Icons/Svgs";
import InputCustom from "../../components/InputCustom/InputCustom";
import { routesMap } from "../../routes";
import styles from "./Home.module.css";
import { useGetAllMacros, useGetAllProducts } from "../../hooks/react-query";

function Home() {
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();
  const { data: dataMacros, status } = useGetAllMacros();
  const { data: dataProducts } = useGetAllProducts();

  useEffect(() => {
    if (window.innerWidth <= 450) {
      setIsMobile(true);
    }
  }, []);

  return (
    <>
      <div className={`container`}>
        <div className={styles["banner"]}>
          <div className={styles["hero-wrapper"]}>
            <div className={styles["banner-typo"]}>
              <span className={styles["span-banner"]}>Catalogo prodotti</span>
              <span className={styles["sub-span-banner"]}>
                Tutti i prodotti e servizi di Motorizzazione in un catalogo
                nazionale facile da esplorare navigando tra i quattro livelli
                proposti o ricercando per parole chiave
              </span>
              <button
                type="button"
                className={`btn btn-primary ${styles["btn-pos"]}`}
                onClick={() => navigate(routesMap.CATALOGO)}
              >
                Vai al catalogo
              </button>
            </div>
          </div>
          {!isMobile && (
            <img
              className={[styles["img-banner"], "col-7"].join(" ")}
              src="https://i.ibb.co/HPL27mX/Immagine-hero-banner.png"
              alt="hero banner"
            />
          )}
        </div>
      </div>

      <div className={styles["w-full"]}>
        <div className={`container ${styles["search-container"]}`}>
          <div className="form-group">
            <InputCustom products={dataProducts} />
          </div>
        </div>

        <div className="container">
          <h1 className={styles["exp-h1"]}>
            Seleziona la macro-categoria di tuo interesse
          </h1>
        </div>

        <div className={`container ${styles["exp-container"]}`}>
          <div className={`${styles["card-exp"]} col-12 col-md-5 col-lg-3`}>
            <div className={styles["exp-c1"]}>
              <SvgVeicoli />
              <span className={styles["span-exp-c"]}>Veicoli</span>
              <span className={styles["sub-span-exp"]}>
                Procedure per immettere e mantenere in circolazione i veicoli
              </span>
                <button type="button" className="btn btn-primary" disabled={status !== "success"} onClick={() => navigate(`${routesMap.CATALOGO}?macro=${
                  dataMacros?.find((el) => el.titolo === "Veicoli").idNodo
                }`)}>
                  Esplora
                </button>
            </div>
          </div>
          <div className={`${styles["card-exp"]} col-12 col-md-5 col-lg-3`}>
            <div className={styles["exp-c1"]}>
              <SvgConducenti />

              <span className={styles["span-exp-c"]}>Conducenti</span>
              <span className={styles["sub-span-exp"]}>
                Patenti e certificazioni di <br />
                guida
              </span>

                <button type="button" className="btn btn-primary" disabled={status !== "success"} onClick={() => navigate(`${routesMap.CATALOGO}?macro=${
                  dataMacros?.find((el) => el.titolo === "Conducenti").idNodo
                }`)}>
                  Esplora
                </button>
            </div>
          </div>
          <div className={`${styles["card-exp"]} col-12 col-md-5 col-lg-3`}>
            <div className={styles["exp-c1"]}>
              <SvgAutotrasporto />

              <span className={styles["span-exp-c"]}>Autotrasporto</span>
              <span className={styles["sub-span-exp"]}>
                Mezzi e conducenti per l'autotrasporto di mezzi e persone
              </span>
                <button type="button" className="btn btn-primary" disabled={status !== "success"} onClick={() => navigate(`${routesMap.CATALOGO}?macro=${
                  dataMacros?.find((el) => el.titolo === "Autotrasporto di merci e persone con titolo autorizzativo").idNodo
                }`)}>
                  Esplora
                </button>
            </div>
          </div>

          <div className={`${styles["card-exp"]} col-12 col-md-5 col-lg-3`}>
            <div className={styles["exp-c1"]}>
              <SvgNautica />

              <span className={styles["span-exp-c"]}>Nautica</span>
              <span className={styles["sub-span-exp"]}>
                Pratiche sui natanti e sulle patenti per condurli
              </span>
                <button type="button" className="btn btn-primary" disabled={status !== "success"} onClick={() => navigate(`${routesMap.CATALOGO}?macro=${
                  dataMacros?.find((el) => el.titolo === "Nautica").idNodo
                }`)}>
                  Esplora
                </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
